import Breadcrumbs from '../breadcrumbs/breadcrumbs';

export default Breadcrumbs;